// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1rmpB","upload":"Small_upload__rS-lT","imageWrap":"Small_imageWrap__2kjBE","removeBtn":"Small_removeBtn__9Vha2"};